import { useEffect, useReducer } from 'react';
import moment from 'moment-timezone';
import WORKER_SCRIPT from './usage_data.worker';

/* Should set BASE_URL on .env or sys ENV `http://hostname:${port}/api/`
 * e.g. http://localhost:8000/api/ or https://restapi.emnet.net/api/
 * */
const BASE_URL = process.env.REACT_APP_REST_API_BASE_URL;

const PORTAL_APP_ID = 1026;
const USER_AUTHENTICATED_EVENT_ID = 1;
const APPLICATION_OPENED_EVENT_ID = 2;
const APPLICATION_CLOSED_EVENT_ID = 3;

let APP_ID = new URLSearchParams(window.location.search).get('app-id');

/*
 *  Check and return a stringify object with
 * `full_token` props a string or accessToken
 * */
function getTokenFromStorage() {
    const PERMANENTTOKEN = window.sessionStorage.getItem('accessToken');
    const ACCESSTOKEN = window.localStorage.getItem('authBody');

    let token = null;

    if (typeof ACCESSTOKEN !== 'undefined' && ACCESSTOKEN !== null) {
        token = `Bearer ${JSON.parse(ACCESSTOKEN).full_token}`;
    } else if (typeof PERMANENTTOKEN !== 'undefined' && PERMANENTTOKEN !== null) {
        token = `Token ${PERMANENTTOKEN}`;
    }

    // DEV TESTING
    // return `Token ${literal_string}`
    return token;
}

/*
 * Returns an object that instantiate the web worker
 */
function initializeWebWorker() {
    return { webWorker: new Worker(WORKER_SCRIPT, { type: 'module' }), baseUrl: BASE_URL };
}

function getCityIdFromStorage() {
    const AUTH_BODY = window.localStorage.getItem('authBody');

    if (AUTH_BODY && AUTH_BODY.cities && AUTH_BODY.cities.length === 1) {
        return AUTH_BODY.cities[0];
    }
}
/*
 *  - Received 0
 *  Bear in mind `app_id` is not APP_ID
 *  the `app_id` is a stringify object
 *  which contains id and timestamp in
 *  session Storage
 **/
function setAppIdTime() {
    const DATE_TIME = moment();
    const APP_ID_CHECK = { id: APP_ID, timestamp: DATE_TIME.tz('UTC').format() };

    window.sessionStorage.setItem('app_id', JSON.stringify(APP_ID_CHECK));
    console.log(window.sessionStorage.getItem('app_id'));
}
/*
 *  - Received 1 param
 * @AppIdTimeStamp {datetime}
 *  datetime from session Storage
 *  to restrict repeated `application opened`
 * event within 15 minutes.
 **/
function compareTimeBeforeSending(AppIdTimeStamp) {
    let canSendAppOpened = false;
    let newMomentDate = moment();

    if (AppIdTimeStamp) {
        let datetime = moment(AppIdTimeStamp);
        let minutesSinceAppOpened = newMomentDate.diff(datetime, 'minutes');

        minutesSinceAppOpened > 15 ? (canSendAppOpened = true) : (canSendAppOpened = false);
    }

    return canSendAppOpened;
}
/*
 * - Received 1 param
 *  @dispatch {func}
 *  the following is alternative function
 *  to send `User Authenticate event`
 *  using dispatch on useContext
 **/
function AlternateSendLogin(dispatch) {
    console.log('sending log user login');

    const APPLICATION_USER_AUTH_EVENT_ID = 1;

    let generatedPayload = generatePayload(APPLICATION_USER_AUTH_EVENT_ID);

    generatedPayload['app_id'] = PORTAL_APP_ID;

    dispatch({ type: 'login', payload: generatedPayload });
}
/*
 *  - Received 1 param
 * @EventId {number} event id
 *  which enables creation of distinct
 *  payload per `user event`
 *  it returns an object
 **/
function generatePayload(eventId) {
    let payload = {};
    let appIdObject = window.sessionStorage.getItem('app_id');
    let AppId = appIdObject == null ? (appIdObject = PORTAL_APP_ID) : JSON.parse(appIdObject)['id'];
    let AppIdTimeStamp = JSON.parse(appIdObject.toString())['timestamp'];
    let cityId = getCityIdFromStorage();

    payload = {
        city_id: cityId,
        event_id: eventId,
        baseUrl: BASE_URL,
        app_id: AppId,
        timestamp: AppIdTimeStamp
    };

    return payload;
}

/*
 *  Checkif 'app_id' has been set on sessionStorage
 *  Bear in mind `app_id` is not APP_ID
 *  the `app_id` set a object which contains id
 *  and timestamp to restrict `event` posting on
 *  refresh
 **/
function CheckAppId() {
    const GET_APP_ID = window.sessionStorage.getItem('app_id');

    return GET_APP_ID !== undefined && GET_APP_ID !== null;
}

/* Received 1
 * @dispatch {func}
 * before sending `Application Opened`
 * event, it checks if there has been
 * a similar event 15 minutes ago.
 * */
function sendAppOpened(dispatch) {
    if (CheckAppId()) {
        let generatedPayload = generatePayload(APPLICATION_OPENED_EVENT_ID);

        const CHECK_LAST_TIME_APP_OPENED = compareTimeBeforeSending(generatedPayload.timestamp);

        if (CHECK_LAST_TIME_APP_OPENED === true) {
            dispatch({ type: 'applicationOpened', payload: generatedPayload });
        } else {
            console.info('Application has been refreshed');
        }
    } else {
        setAppIdTime(APP_ID);

        let generatedPayload = generatePayload(APPLICATION_OPENED_EVENT_ID);

        dispatch({ type: 'applicationOpened', payload: generatedPayload });

        console.log('Initialize application opened');
    }
}

/*
 *  This is an ad hoc function that handles
 *  sending `User Authenticated` event before finding
 *  a better way to do it with dispatch on
 *  Context.Provider
 */
function SendUserLogging() {
    console.info(`Sending user successful login to ${BASE_URL}`);

    const WEB_WORKER = new Worker(WORKER_SCRIPT, { type: 'module' });

    let token = getTokenFromStorage();
    let payload = generatePayload(USER_AUTHENTICATED_EVENT_ID);

    WEB_WORKER.postMessage({ ...payload, ...{ token } });
}

/* Received 2
 *  @state {object}
 *  @ action {object}
 *  The famous reducer for useReducer
 */
const Reducer = (state, action) => {
    action.payload = action.payload ? action.payload : {};

    let token = getTokenFromStorage();

    switch (action.type) {
        case 'init':
            console.log('Initialization::Dev');

            break;
        case 'login':
            state.webWorker.postMessage({
                event_id: action.payload['event_id'],
                app_id: action.payload['app_id'],
                city_id: action.payload['city_id'],
                baseUrl: state.baseUrl,
                token
            });

            return { ...state };
        case 'applicationOpened':
            state.webWorker.postMessage({
                event_id: action.payload['event_id'],
                app_id: action.payload['app_id'],
                city_id: action.payload['city_id'],
                baseUrl: state.baseUrl,
                token
            });

            return { ...state };
        case 'applicationClosed':
            console.log('application close');

            fetch(`${state.baseUrl}/api/tables/usage-data/`, {
                method: 'POST',
                cache: 'no-cache',
                mode: 'cors',
                keepalive: true,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                },
                body: JSON.stringify({
                    event_id: action.payload['event_id'],
                    app_id: action.payload['app_id'],
                    city_id: action.payload['city_id']
                })
            });

            return { ...state };
        default:
            throw new Error();
    }
};
/* Received 1
 * @baseUrl {string}
 *  REST API Origin e.g: http://emnet.restapi.net
 *  return a dispatch
 * */
export const useUsageTracking = () => {
    const [STATE, dispatch] = useReducer(Reducer, { webWorker: null }, initializeWebWorker);
    const CITY_ID = getCityIdFromStorage();
    
    useEffect(() => {
        // send `Application Opened` after the page has painted
        sendAppOpened(dispatch);

        const ApplicationClosedListener = () => {
            dispatch({
                type: 'applicationClosed',
                payload: { app_id: APP_ID, event_id: APPLICATION_CLOSED_EVENT_ID, city_id: CITY_ID }
            });
        };

        window.addEventListener('beforeunload', ApplicationClosedListener);

        return () => window.removeEventListener('beforeunload', ApplicationClosedListener);
    }, []);

    return dispatch;
};

export { SendUserLogging };
